// @flow
import { createSelector } from "reselect";
import type {
  AuthenticationStateType,
  CookieStateType,
  UserProfile,
} from "../types";

export type AuthenticationState = {
  authentication: AuthenticationStateType;
  cookie: CookieStateType;
};

export const authenticationSelector = (
  state: AuthenticationState,
): AuthenticationStateType => state.authentication;

export const cookieSelector = (state: AuthenticationState): CookieStateType =>
  state.cookie;

const authenticatedUserDataSelector = createSelector(
  authenticationSelector,
  (auth) => auth.authenticatedUserData,
);

export const userProfileSelector = createSelector(
  authenticatedUserDataSelector,
  (profile): UserProfile | null => {
    if (!profile) return null;

    return {
      firstName: profile.firstName,
      lastName: profile.lastName,
      email: profile.email,
      telephone: profile.telephone,
      preferredLocale: profile.preferredLocale,
    };
  },
);

export const userBranchName = (state: AuthenticationState): string =>
  state.authentication?.authenticatedUserData?.tposBranch?.name || "";

export const preferredLocaleSelector = createSelector(
  userProfileSelector,
  (userData) => userData?.preferredLocale,
);

export const getTelephoneNumberDisplay = createSelector(
  userProfileSelector,
  (userData) => {
    const telephone9Digit = userData?.telephone
      ? userData?.telephone.substr(5, 9)
      : "";
    return telephone9Digit;
  },
);

export const getUserId = createSelector(
  authenticatedUserDataSelector,
  (user) => user?.id,
);

export const getBranchId = createSelector(
  authenticatedUserDataSelector,
  (user) => user?.tposBranch?.id,
);

export const isUserAuthenticated = createSelector(
  [cookieSelector],
  (cookie) => cookie?.registerUserToken,
);

export const isFcmTokenUpdated = (state: AuthenticationState): boolean =>
  state.authentication.isFcmTokenUpdated;
